<template>
	<!-- 新建商品组弹框 -->
	<span>
		<!-- 选择货盘联系人和新建货盘联系人弹框，选择商品来源 -->
		<el-dialog width="520px" :title="dialogName" :visible.sync="dialogChooseVisible" :close-on-click-modal="false" @close="resetForms('contactFrom')">
			<el-form :model="formData" ref="contactFrom" :rules="contactRules">
				<!-- 添加联系人状态 -->
				<template v-if="isAddContact">
					<el-form-item label="联系人姓名" :label-width="formLabelWidth" prop="contact_name">
						<el-input v-model="formData.contact_name" autocomplete="off" placeholder="请填写货盘联系人姓名"></el-input>
					</el-form-item>
					<el-form-item label="手机号" :label-width="formLabelWidth" prop="contact_mobile">
						<el-input v-model="formData.contact_mobile" autocomplete="off" placeholder="请填写货盘联系人手机号"></el-input>
					</el-form-item>
					<el-form-item label="微信号" :label-width="formLabelWidth" prop="contact_wechat">
						<el-input v-model="formData.contact_wechat" autocomplete="off" placeholder="请填写货盘联系人微信号"></el-input>
					</el-form-item>
				</template>
				<!-- 非添加联系人状态 -->
				<template v-else>
					<el-form-item label="选择货盘联系人" label-width="130px" prop="contact_id">
						<el-select v-model="formData.contact_id" placeholder="请选择" @change="selectRole" class="width100">
							<el-option v-for="(item, index) in contactList" :key="index" :label="item.contact_name" :value="item.contact_id">
								<div class="flex-row flex-just-between">
									<span>{{ item.contact_name }}</span>
									<span>{{ item.contact_mobile }}</span>
								</div>
							</el-option>
						</el-select>
						<el-button type="text" @click="addContact">找不到货盘联系人？建立新的货盘联系人</el-button>
					</el-form-item>
					<!-- 非单平台展示选择商品来源 -->
					<el-form-item label="商品来源" v-if="notSingleVersion" label-width="130px" prop="platform_id">
						<el-radio-group v-model="formData.platform_id" @change="platformChange">
							<el-radio :label="item.value" v-for="item in platformList" :key="item.value">{{ item.label }}</el-radio>
						</el-radio-group>
					</el-form-item>
				</template>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addContactCancel" v-if="isAddContact">取消</el-button>
				<el-button type="primary" @click="nextStep">下一步</el-button>
			</div>
		</el-dialog>
		<!-- 导入货盘弹窗 -->
		<el-dialog title="导入货盘" :visible.sync="dialogBatchVisible" show-close>
			<div class="import-content">
				<el-steps :active="4" align-center>
					<el-step>
						<div slot="title" class="title">选择货盘信息</div>
						<div slot="description">
							<p class="yx-color-text-secondary mb-22">选择货盘联系人及货盘来源，便于溯源</p>
							<p class="flex-row yx-color-text-primary">
								<span class="label">联系人：</span>
								<span>{{ contactObj.contact_name }}</span>
							</p>
							<p class="flex-row yx-color-text-primary">
								<span class="label">联系方式：</span>
								{{ contactObj.contact_mobile }}
							</p>
							<p class="flex-row yx-color-text-regular">
								<span class="label">来源：</span>
								{{ targetPlatformName }}
							</p>
						</div>
					</el-step>
					<el-step>
						<div slot="title" class="title">下载模板</div>
						<div slot="description">
							<p class="yx-color-text-secondary mb-22">使用模板进行上传系统才可识别</p>
							<a :href="importFilePath" target="_blank" class="link">下载批量导入模板</a>
						</div>
					</el-step>
					<el-step>
						<div slot="title" class="title">补充/修改信息</div>
						<div slot="description">
							<p class="yx-color-text-secondary">按照下载的模板补充相应的字段</p>
						</div>
					</el-step>
					<el-step>
						<div slot="title" class="title">导入</div>
						<div slot="description">
							<p class="yx-color-text-secondary">将填写好的表格导入到平台</p>
						</div>
					</el-step>
				</el-steps>
			</div>
			<span slot="footer">
				<upload-file accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @upload="importOrder">
					<el-button type="primary">导入货盘</el-button>
				</upload-file>
			</span>
		</el-dialog>
		<!-- 批量导入结果弹窗 -->
		<el-dialog title="导入结果" :visible.sync="resultDialogVisble" width="520px" show-close :close-on-click-modal="false">
			<div class="result-content">
				<!-- 全部导入成功 -->
				<p v-if="importResult.status == 1" class="flex-row flex-align-center">
					<i class="iconfont icon-a-check-circlewancheng-mian fz-28 yx-color-success mr-12"></i>
					共计
					<span class="yx-color-primary yx-pingfang-semibold ml-4 mr-4">{{ importResult.success_num }}</span>
					个商品，全部导入成功！
				</p>
				<!-- 无法识别表格内容 -->
				<div v-if="importResult.status == 2">
					<p class="flex-row flex-align-center">
						<i class="iconfont icon-a-close-circleguanbi-yuan-mian fz-28 yx-color-danger mr-12"></i>
						无法识别表格内容，请确认是否按照模板填写！如有疑问请联系客服！
					</p>
				</div>
				<!-- 部分导入失败 -->
				<div v-if="importResult.status == 3">
					<p>
						共计上传
						<span class="yx-color-primary yx-pingfang-semibold ml-4 mr-4">{{ importResult.success_num + importResult.fail_num }}</span>
						个商品 导入成功
						<span class="yx-color-primary yx-pingfang-semibold ml-4 mr-4">{{ importResult.success_num }}</span>
						个商品， 导入失败
						<span class="ml-4 mr-4" :class="{ 'yx-color-danger': importResult.fail_num != 0 }">{{ importResult.fail_num }}</span>
						个商品， 可以下载导入失败的商品，查看失败原因，修改后重新导入
					</p>
				</div>
			</div>
			<span slot="footer">
				<el-button type="primary" v-if="importResult.status == 1" @click="confirm">确认</el-button>
				<!-- 非导入全部成功展示重新导入发货单和联系客服 -->
				<div v-else class="flex flex-align-center flex-just-end">
					<el-tooltip placement="top">
						<img slot="content" :src="baseInfo.products_fail_code" alt="" width="160" height="160" />
						<a href="javascript:;" class="fz-14 mr-20 link yx-color-text-regular">遇到困难？联系客服</a>
					</el-tooltip>
					<el-button type="primary" plain @click="downloadFailFile">下载导入失败的商品</el-button>
					<upload-file
						accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
						@upload="importOrder"
						class="ml-14"
					>
						<el-button type="primary">重新导入</el-button>
					</upload-file>
				</div>
			</span>
		</el-dialog>
	</span>
</template>
<script>
import UploadFile from '@/components/common/UploadFile';
import { importPallet, addPalletContact, palletContactList, exprotFailPallet } from '@/api/shopManage';
import { checkTextLength, validateTel } from '@/utils/validate';
import { mapGetters, mapState } from 'vuex';
import mixin from '@/mixins';
import { PLATFORM_DY, PLATFORM_KS, PLATFORM_OBJ } from '@/utils/dataMap';
// todo zty
const confs = {
	[PLATFORM_DY.value]: {
		link: 'https://cdn.chaoyongbushou.com/partner/t/pallet/货盘模板抖音0612.xls',
	},
	[PLATFORM_KS.value]: {
		link: 'https://cdn.chaoyongbushou.com/partner/t/pallet/货盘模板快手0612.xls',
	},
};
export default {
	name: 'exportDialog',
	mixins: [mixin],
	components: {
		UploadFile,
	},
	computed: {
		...mapGetters(['defaultPlatform', 'notSingleVersion', 'isSingleVersion']),
		importFilePath() {
			return confs[+this.platformId]?.link || '';
		},
		targetPlatformName() {
			return PLATFORM_OBJ[+this.platformId]?.label || '';
		},
		platformList() {
			return [PLATFORM_DY, PLATFORM_KS];
		},
	},
	data() {
		return {
			dialogBatchVisible: false,
			dialogChooseVisible: false,
			resultDialogVisble: false,
			formData: {
				platform_id: '',
				contact_id: '',
				contact_name: '',
				contact_mobile: '',
				contact_wechat: '',
			},
			contactObj: {},
			isAddContact: false,
			formLabelWidth: '100px',
			contactRules: {
				contact_id: [{ required: true, message: '选择货盘联系人', trigger: 'blur' }],
				platform_id: [{ required: true, message: '请选择商品来源', trigger: 'blur' }],
				contact_name: [{ required: true, validator: checkTextLength, trigger: 'blur' }],
				contact_mobile: [{ required: true, validator: validateTel, trigger: 'blur' }],
				contact_wechat: [{ required: true, message: '请输入微信号', trigger: 'blur' }],
			},
			importResult: {
				pallet_id: 0,
				status: '',
				success_num: '',
				fail_num: '',
			},
			platformId: '',
			dialogName: '选择货盘信息',
			contactList: [],
		};
	},
	created() {
		// 如果只开通了一个平台，那么就设置平台ID为绑定的平台ID
		if (this.isSingleVersion) {
			this.formData.platform_id = this.platformId = `${this.defaultPlatform}`;
		}
	},
	methods: {
		//上传货盘
		show() {
			this.dialogName = '选择货盘信息';
			this.contactObj = {};
			this.dialogChooseVisible = true;
			this.isAddContact = false;
			this.getContactList();
		},
		async getContactList() {
			return new Promise(async (rs, rj) => {
				try {
					const data = await palletContactList();
					this.contactList = data;
					rs(data);
				} catch (error) {
					this.$message.error(error.message);
					rj();
				}
			});
		},
		//新建联系人
		addContact() {
			this.isAddContact = true;
			this.dialogName = '新建货盘联系人';
			this.resetFormData();
			this.resetForms('contactFrom');
		},
		//下一步
		nextStep() {
			this.importResult = {
				pallet_id: 0,
				status: '',
				success_num: '',
				fail_num: '',
			};
			this.$refs['contactFrom'].validate(async valid => {
				if (valid) {
					//判断是否为新建联系人弹框
					if (this.isAddContact) {
						await addPalletContact(this.formData);
						const [target] = await this.getContactList();
						this.contactObj = target;
						this.formData.contact_id = target.contact_id;
						this.addContactCancel();
					} else {
						this.dialogChooseVisible = false;
						this.dialogBatchVisible = true;
					}
				}
			});
		},
		/**
		 * @description: 新建联系人取消时
		 * 还原新建联系人所填信息，清空表单校验，还原弹窗标题，还原isAddContact状态
		 * @return {*}
		 * @acthor: Li Yong
		 * @Date: 2022-06-15 14:13:38
		 */
		addContactCancel() {
			const oldData = this.$options.data();
			this.isAddContact = oldData.isAddContact;
			this.formData.contact_name = oldData.formData.contact_name;
			this.formData.contact_mobile = oldData.formData.contact_mobile;
			this.formData.contact_wechat = oldData.formData.contact_wechat;
			this.dialogName = oldData.dialogName;
			this.$refs.contactFrom.clearValidate();
		},
		//上传货盘
		async importOrder(data) {
			data.append('contact_id', this.contactObj.contact_id);
			data.append('pallet_id', this.importResult.pallet_id);
			data.append('platform_id', this.platformId);
			try {
				const res = await importPallet(data);
				if (res?.code == 0) {
					this.importResult = {
						status: res?.data?.fail_num == 0 ? 1 : 3,
						...res.data,
					};
					// 全部成功或者部分成功之后刷新列表数据
					this.$emit('refreshList');
					this.resultDialogVisble = true;
				} else {
					this.resultDialogVisble = false;
				}
				this.dialogBatchVisible = false;
			} catch (error) {
				console.log(error);
			}
		},
		// 导出失败订单
		async downloadFailFile() {
			try {
				this.loading = true;
				const { download_url } = await exprotFailPallet({ pallet_id: this.importResult.pallet_id });
				window.open(download_url, '_blank');
				this.loading = false;
			} catch (error) {
				if (error.code === -1) {
					this.$message.error(error.message);
				}
				this.loading = false;
			}
		},
		//选择联系人
		selectRole(e) {
			this.contactObj = this.contactList.find(item => item.contact_id === e);
		},
		confirm() {
			this.resultDialogVisble = false;
		},
		//重置弹框表单
		resetForms(from) {
			this.$refs[from].resetFields();
		},
		// 重置表单数据
		resetFormData() {
			this.contactObj = {};
			this.formData = {
				platform_id: '',
				contact_id: '',
				contact_name: '',
				contact_mobile: '',
				contact_wechat: '',
			};
		},
		platformChange(e) {
			this.platformId = e;
		},
	},
};
</script>
<style lang="less" scoped>
.import-content {
	width: 100%;
	padding: 30px 0;
	background: #f8f8f8;
	box-sizing: border-box;
	.title {
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #323233;
	}
	.desc {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #969799;
		line-height: 18px;
	}
}
.pallut-contact-box {
	margin-top: 34px;
}
.label {
	display: inline-block;
	width: 80px;
	text-align: right;
}
/deep/.el-step.is-center .el-step__description {
	padding-left: 10%;
	padding-right: 10%;
}
</style>
